import {
  BUSINESS_OPPORTUNITY_FINDER_PRIO,
  BusinessOpportunityFinderApi,
} from 'legacy/lut/classes/services/api/partner360/BusinessOpportunityFinderApi'

import {
  BaseFetcher,
  ICrudImplementation,
  IPaging,
  TCreateFunction,
  TFetcher,
  TUpdateFunction,
} from 'core-components/types'
import { IFilter } from 'core-components/types'

export class BusinessOpportunityFinderApiFetcher<IBusinessOpportunityRow>
  extends BaseFetcher<IBusinessOpportunityRow>
  implements ICrudImplementation<IBusinessOpportunityRow>
{
  private mode: BUSINESS_OPPORTUNITY_FINDER_PRIO = BUSINESS_OPPORTUNITY_FINDER_PRIO.INDUSTRY

  public create: TCreateFunction<IBusinessOpportunityRow> = async () => {
    return []
  }

  public update: TUpdateFunction<IBusinessOpportunityRow> = async () => {
    return []
  }

  // @ts-ignore
  public read: TFetcher<IBusinessOpportunityRow> = async (query, filter, sort, paging: IPaging) => {
    const customerMode = (filter.filters as IFilter[]).find((f) => f.field === 'customerMode')
    if (customerMode && this.mode !== customerMode.value) {
      this.mode = customerMode.value as BUSINESS_OPPORTUNITY_FINDER_PRIO
      this.subscribersCall(true)
    }
    return await BusinessOpportunityFinderApi.call(this.mode, paging, filter)
  }

  public clone(): BusinessOpportunityFinderApiFetcher<IBusinessOpportunityRow> {
    return new BusinessOpportunityFinderApiFetcher()
  }

  public getStaticData = () => {
    return [this.mode]
  }
}
